import { createSlice } from "@reduxjs/toolkit";

export const PackageIdSlice = createSlice({
  name: "Package-Id",
  initialState: {
    packageId: "",
  },
  reducers: {
    setPackageId: (state, action) => {
      state.packageId = action.payload;
    },
  },
});

export const { setPackageId } = PackageIdSlice.actions;

export default PackageIdSlice.reducer;
